/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CreditAlertPanelComponent from "./creditAlertPanel.component";
import { selectLoading } from "modules/notification";
import {
  getCreditAlertInfo,
  resetCreditAlert,
  updateCreditAlertInfo,
} from "modules/campaign/consumer-engagement/redux";
import { TngDisbursementContext } from "../tngDisbursementSettingPanel/tngDisbursementSettingPanel.container";
import {canAccess} from "../../../../../profile/redux/selector/profile.selector";
import {AccessRights} from "../../../../../../lib/constants/accessRights";

export default function CreditAlertPanelContainer() {
  const dispatch = useDispatch();
  const lang = useSelector((state) => state.constant.languages);
  const isFetching = useSelector((state) =>
    selectLoading(state, getCreditAlertInfo.typePrefix)
  );
  const alertInfo = useSelector((state) => state.disbursement.alertInfo);
  const isSubmitting = useSelector((state) =>
    selectLoading(state, updateCreditAlertInfo.typePrefix)
  );

  const canEditCreditAlert = useSelector(
    (state) => canAccess(state, AccessRights.Company.CONSUMER_ENGAGEMENT_WRITE_UPDATE_CREDIT_ALERTS)
  );

  const { disbursementInfo } = useContext(TngDisbursementContext);

  const [isEdit, setIsEdit] = useState(false);

  useEffect(() => {
    handleDataLoad();
    return () => {
      dispatch(resetCreditAlert());
    };
  }, []);

  const handleDataLoad = () => {
    dispatch(getCreditAlertInfo());
  };

  const handleSubmit = (values) => {
    dispatch(
      updateCreditAlertInfo({
        has_alert: values.hasAlert,
        alert_email: values.recipients,
        alert_threshold: values.alertThreshold,
        transaction_threshold: values.transactionThreshold,
      })
    ).then(() => {
      handleDataLoad();
      setIsEdit(false);
    });
  };

  return (
    <CreditAlertPanelComponent
      lang={lang}
      alertInfo={alertInfo}
      isFetching={isFetching}
      isError={alertInfo.isError}
      handleReload={handleDataLoad}
      isEdit={isEdit}
      setIsEdit={setIsEdit}
      handleSubmit={handleSubmit}
      isSubmitting={isSubmitting}
      disbursementInfo={disbursementInfo}
      canEditCreditAlert={canEditCreditAlert}
    />
  );
}
